import faqUrlByLocales from './faqUrlByLocales.json';

export const FAQ_URL_BY_LOCALES = faqUrlByLocales;
